import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { accountingCurrencyFormatter } from "@common/helpers/currency";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    SCHEDULE_APPLICATIONS_EMPTY_VALUE,
    ScheduleApplicationRow,
} from "../scheduleApplicationRowHelpers";
import styles from "./ScheduleApplicationAmountCells.module.scss";

function formatAmount(amount: number | null): string {
    return amount == null
        ? SCHEDULE_APPLICATIONS_EMPTY_VALUE
        : accountingCurrencyFormatter.format(amount);
}

export const ScheduleApplicationAmountCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ScheduleApplicationRow,
        number | null
    >) => {
        const rowData = row.original;
        return (
            <ViewTableCell>
                <span className={styles.amount}>
                    {formatAmount(rowData.amount)}
                </span>
            </ViewTableCell>
        );
    },
);
ScheduleApplicationAmountCell.displayName = "ScheduleApplicationAmountCell";

export const ScheduleApplicationRemainingBalanceCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        ScheduleApplicationRow,
        number | null
    >) => {
        const rowData = row.original;
        return (
            <ViewTableCell>
                <span className={styles.amount}>
                    {formatAmount(rowData.remainingAmount)}
                </span>
            </ViewTableCell>
        );
    },
);
ScheduleApplicationRemainingBalanceCell.displayName =
    "ScheduleApplicationRemainingBalanceCell";
